splitMessage